export const convertJrToSotetsu = (jrTrainNumber => {
  let trainNumber = jrTrainNumber.replace(/\s|M/g, '')

  if (120 <= trainNumber && trainNumber <= 199) { // 相鉄線内特急
    return String(3000 + Number(trainNumber))
  } else if(220 <= trainNumber && trainNumber <= 299) { // 相鉄線内各停
    return String(6000 + Number(trainNumber))
  }/* else if(9120 <= trainNumber && trainNumber <= 9199) { // 相鉄線内特急(臨時)
    return String(-1000 + trainNumber)
  } else if(9220 <= trainNumber && trainNumber <= 9299) { // 相鉄線内各停(臨時)
    return String(-1000 + trainNumber)
  } else if(9220 <= trainNumber && trainNumber <= 9299) { // 相鉄線内回送(臨時)
    return String(-200 + trainNumber)
  } else if(9120 <= trainNumber && trainNumber <= 9199) { // 相鉄線内試運転(臨時)
    return String(trainNumber)
  } else if(9220 <= trainNumber && trainNumber <= 9299) { // 相鉄線内回送
    return String(-1000 + trainNumber)
*/
})

export const convertSotetsuToJr = (trainNumberString => {
  const trainNumber = Number(trainNumberString)
  if (3120 <= trainNumber && trainNumber <= 3199) { // 相鉄線内特急
    return ' ' + String(trainNumber - 3000) + 'M'
  } else if(6220 <= trainNumber && trainNumber <= 6299) { // 相鉄線内各停
    return ' ' + String(trainNumber - 6000) + 'M'
  }
})

export const isJrThruTrain = (trainNumberString => {
  const trainNumber = Number(trainNumberString)
  return (3120 <= trainNumber && trainNumber <= 3199) || (6220 <= trainNumber && trainNumber <= 6299)
})

export const isTokyuThruTrain = (trainNumberString => {
  if (trainNumberString.length === 6) {
    return true
  }
  const trainNumber = Number(trainNumberString)
  return (
    (1700 <= trainNumber && trainNumber <= 1999) || 
    (2700 <= trainNumber && trainNumber <= 2999) || 
    (3700 <= trainNumber && trainNumber <= 3999) || 
    (4700 <= trainNumber && trainNumber <= 4999) || 
    (5700 <= trainNumber && trainNumber <= 5999) || 
    (6400 <= trainNumber && trainNumber <= 6699) || 
    (7400 <= trainNumber && trainNumber <= 7699) || 
    (8700 <= trainNumber && trainNumber <= 8999) || 
    (9700 <= trainNumber && trainNumber <= 9999)
  )
})

export const isTokyuTrain = (trainNumberString => {
  return (trainNumberString.length === 6)
})

export const getDirectionFromTrainNo = (trainNo) => {
  const trainNoNumber = Number(trainNo.replace('M', ''))
  return (trainNoNumber % 2 === 0 ? 'up' : 'down')
}
